import { heroEquipment } from "../HeroEquipment";

export const siostry = {
  heroes: {
    Przeorysza: {
      id: 0,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Siostry Sigmara"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Arcykapłan","Czarostwo","Duchowny (modlitwy do Sigmara)","Dowódca","Modlitwa","Nienawiść","Rozproszenie magii (2)"],
      exp: 20,
      skills: [0, 2, 3, 4, 5],
    },
    "Prezbiter Sigmara": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Siostry Sigmara"].Prezbiter,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarostwo",
        "Duchowny (modlitwy do Sigmara)",
        "Modlitwa",
        "Nienawiść",
        "Przepastne trzewia",
        "Rozproszenie magii (2)",
      ],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    "Siostra bitwy": {
      id: 2,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Siostry Sigmara"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Nienawiść", "Podoficer"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Szpitalniczka: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 1,
      equipmentList: heroEquipment["Siostry Sigmara"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Felczer", "Nienawiść"],
      exp: 0,
      skills: [0, 2, 4, 5],
    },
    Nowicjuszka: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Siostry Sigmara"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Nienawiść"],
    },
    "Siostra Sigmara": {
      id: 5,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 30,
      number: 5,
      equipmentList: heroEquipment["Siostry Sigmara"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Nienawiść"],
    },
    Pokutnica: {
      id: 6,
      startingEquipment: ["Cep bojowy"],
      cost: 40,
      number: 5,
      equipmentList: heroEquipment["Siostry Sigmara"].Pokutnica,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 4, 1, 3, 1, 10],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Fanatyk", "Furia", "Nienawiść"],
    },
    "Rycerz zakonny": {
      id: 7,
      startingEquipment: ["Sztylet", "Miecz", "Koń bojowy", "Siodło & uprząż"],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Siostry Sigmara"]["Rycerz zakonny"],
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: [
        "Duży cel (wierzchem)",
        "Kawalerzysta",
        "Szermierz",
        "Zabójczy cios",
      ],
    },
    "Bitewny ołtarz": {
      id: 8,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: [
        "Bitewny ołtarz",
        "Duży cel",
        "Machina wojenna",
        "Strach",
        "Powóz",
      ],
    },
    Rydwan: {
      id: 9,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Siostry Sigmara",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Podatek", "Rozrzutność"],
  mercenaries: [
    "Kartograf",
    "Kupiec",
    "Łowca czarownic",
    "Łowca nagród",
    "Pogromca Trolli",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Tileański kusznik",
    "Woźnica",
    "Zwiadowca",
  ],
};
